import React from 'react';
import GlobalStyles from 'styles/GlobalStyles';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLandingPage from 'MainLandingPage';
import WabaAdmin from 'pages/WabaAdmin';

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path='/' element={<MainLandingPage />} />
          <Route path='/waba-admin' element={<WabaAdmin />} />
          <Route path='*' element={<MainLandingPage />} />
        </Routes>
      </Router>
    </>
  );
}
